import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { debounce } from 'lodash';
import { StringConstants } from '../../containers/WorkkardDetail/constants';
import LoaderComponent from '../Loader';
import {
    clearErrorValidationMessage,
} from '../../containers/SpockViewPage/actions/action';
;
import UserImage from '../UserImage/index';
import { isMobile } from '../../common/util';

class changeOwnerPopUp extends React.PureComponent {
    wrapperRef;
    ownerListRef;
    ownerListLiRef

    constructor(props) {
        super(props);
        this.state = {
            clickedItem: null,
            errorMsg: '',
            selectedSponsor: null,
            sponsors: [],
            searchText: '',
            cursor: 0,
        }
        this.changeOwner = this.changeOwner.bind(this);
        this.clickedItem = this.clickedItem.bind(this);
        this.search = debounce(this.search.bind(this), 300);
        this.cancelClick = this.cancelClick.bind(this);
        this.onClickChange = this.onClickChange.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancelOutside = this.handleCancelOutside.bind(this);
        this.timeOut = null;
    }

    // unmount  component and remove all listners
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
        this.props.clearErrorValidationMessage();
    }

    // handle key event like scroll up scroll down enter
    handleKeyDown(e) {
        const { cursor, sponsors } = this.state
        let cursorVal = cursor;
        // on press arrow up
        if (e.keyCode === 38 && cursor > 0 && this.ownerListRef && this.ownerListLiRef) {
            e.preventDefault();
            cursorVal = cursor - 1
            this.ownerListRef.scrollTo({ top: (this.ownerListLiRef.scrollHeight + 1) * cursorVal });
        }
        // on press arrow down
        else if (e.keyCode === 40 && cursor < sponsors.length - 1 && this.ownerListRef && this.ownerListLiRef) {
            e.preventDefault();
            cursorVal = cursor + 1;
            this.ownerListRef.scrollTo({ top: (this.ownerListLiRef.scrollHeight + 1) * cursorVal });
        }
        // handle when scroll ends to last element of list
        else if (e.keyCode === 40 && cursor === sponsors.length - 1) {
            e.preventDefault();
            cursorVal = 0;
            this.ownerListRef.scrollTo({ top: (this.ownerListLiRef.scrollHeight) * 1 });
        }
        //handle when enter button pressed
        if (e.keyCode === 13) {
            e.preventDefault();
            const obj = this.state.sponsors[this.state.cursor];
            this.clickedItem(obj, this.state.cursor)
        }

        // handle close pop up when press ESC button

        if (e.keyCode === 27) {
            this.cancelClick();
        }
        this.setState({
            cursor: cursorVal
        });
    }

    // close component  when  detect  out side  click
    handleOutsideClick(event) {
        // if (!!this.wrapperRef.contains(event.target)) {
        // } else {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.handleCancelOutside();
        }
    }

    //set refs
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    // set listner
    // fetch  workard or activity data by id
    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
        if (this.props && this.props.sponsors) {
            this.setState({
                selectedSponsor: null,
                orignalSponsors: this.props.sponsors,
                sponsors: this.props.sponsors,
            })
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!!nextProps.errorMessage && this.state.errorMsg == '') {
            this.setState({
                errorMsg: nextProps.errorMessage
            })
        }

        if (nextProps && nextProps.sponsors.length !== this.props.sponsors.length) {
            this.setState({
                clickedItem: null,
                selectedSponsor: null,
                orignalSponsors: nextProps.sponsors,
                sponsors: nextProps.sponsors,
            })
        }

    }

    // handle  when click to  change owner
    onClickChange() {
        this.props.onCLickChangeButton()
    }

    // heighlight clicked  item
    clickedItem(obj, key) {
        this.setState({
            clickedItem: obj.UserId,
            selectedSponsor: obj,
            cursor: key,
        })
    }

    // reset  state when  click out  side
    handleCancelOutside() {
        if (this.props.expand) {
            this.cancelClick()
        }
    }

    // cancel  click handler
    cancelClick() {
        if (this.props.buttonLoading) {
            return;
        }
        this.setState({
            clickedItem: null,
            errorMsg: '',
            selectedSponsor: null,
            sponsors: [],
            searchText: '',
            cursor: 0,
        });
        // this.search();
        if (this.props.closePopUp) {
            this.props.closePopUp()
        }
    }

    // submit  change  request
    changeOwner() {
        if (this.props.buttonLoading) {
            return;
        }
        this.props.changeOwner({ selectedUser: this.state.selectedSponsor });
    }

    // search when  key  up and update  state
    search() {
        const searchText = this.state.searchText.toLocaleLowerCase().trim();
        var filteredArr = this.state.orignalSponsors;
        if (searchText) {
            filteredArr = this.state.orignalSponsors && this.state.orignalSponsors.filter((object) => {
                return object.DisplayName.toLowerCase().search(searchText) !== -1 ||
                    object.Title.toLowerCase().search(searchText) !== -1 ||
                    object.Email.toLowerCase().search(searchText) !== -1
            })
        }
        if (this.state.sponsors.length !== filteredArr.length) {
            this.setState({
                cursor: 0
            })
        }
        this.setState({
            sponsors: filteredArr,
        })
    }

    onMouseEnter = (e, id) => {
        const targetRect = e.currentTarget.getBoundingClientRect();
        this.timeOut = setTimeout(() => this.props.openMiniProfile(targetRect, this.props.currentOwner.id), 500)
    }

    onMouseLeave = () => {
        clearTimeout(this.timeOut)
    }

    render() {
        const userPopupClass = `dropDown onClick alignMiddle flexGrow`
        const { canChange, expand, changeSuccess, changeError, isMob } = this.props;
        let webPopupStyle = !isMobile() ? this.props.style : {};
        return (
            <>
                {/* {isMobile()&& expand&& <div className="transparentOverlay"></div >} */}

                {
                    !changeSuccess && !expand ?
                        <React.Fragment>
                            <div className={`${isMobile() && expand ? "changeOwnerMob" : ""} rowFlex`} ref={(node) => this.setWrapperRef(node)} id={this.props.id} style={this.props.style}>
                                <div className="userGroup">
                                    <div id="changeOwnerList" className={userPopupClass}>
                                        <div className={`rowFlex ${this.props.currentOwner && this.props.currentOwner.userClass || ''}`}>
                                            <div className="userPic userPicIcon" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                                                <UserImage profileUrl={this.props.currentOwner.profileImage} profileName={this.props.currentOwner.name} />
                                            </div>
                                            <div className="userInfo colFlex flexWrap">
                                                <span className="name">
                                                    {
                                                        this.props.currentOwner.name
                                                    }{((this.props.type === 'changeWorkKardOwner' && this.props.workkard.IsSponsorBlocked) || (this.props.type === 'changeActivityOwner' && this.props.activityDetail.isOwnerBlocked)) && (<span class="gray"> (Inactive)</span> )}
                                                </span>
                                                <label>{this.props.type === 'changeWorkKardOwner' ? StringConstants.WorkkardOwnerText : StringConstants.ActivityOwnerText}</label>
                                            </div>
                                        </div>
                                        {
                                            !expand && canChange &&
                                            <span className="change"> <a className="" href="javascript:void(0)" onClick={this.onClickChange}>change </a></span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>

                        :
                        <React.Fragment>
                            <div  ref={  (node) => !isMobile() && this.setWrapperRef(node)} id={this.props.id} style={webPopupStyle}>
                                <div id="changeOnwerPopup" className={userPopupClass}>

                                    <div className={expand ? `dropDownMenu ownerPopup onClick animated fast ` : ""}>
                                        {(!this.props.isLoading && expand) ?
                                            <React.Fragment>
                                                <div className={`elementUp rowFlex userGroup ${changeError ? 'elementHide' : ''}`}>
                                                    <div className="userPic userPicIcon" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                                                        <UserImage profileUrl={this.props.currentOwner.profileImage} profileName={this.props.currentOwner.name} />
                                                    </div>
                                                    <div className="userInfo colFlex flexWrap">
                                                        <span className="name">
                                                            {
                                                                this.props.currentOwner.name
                                                            }
                                                        </span>
                                                        <label>{this.props.type === 'changeWorkKardOwner' ?
                                                            StringConstants.WorkkardOwnerText :
                                                            StringConstants.ActivityOwnerText}</label>
                                                    </div>
                                                </div>
                                                <div className="searchOwner">
                                                    <div className="formGroup">
                                                        <input tabIndex={1} onKeyDown={this.handleKeyDown} autoFocus={isMob ? false : true} className="line" type="text" placeholder="Search by Name, Job Title or Email" onChange={(e) => this.setState({ searchText: e.target.value })} onKeyUp={this.search} />
                                                    </div>
                                                </div>
                                                {
                                                    <div ref={(node) => { this.ownerListRef = node }} className="ownerList">
                                                        <ul>
                                                            {this.state.sponsors && this.state.sponsors.map((obj, key) => {
                                                                return (
                                                                    <li ref={(refNode) => { this.ownerListLiRef = refNode }} tabIndex={0} onKeyDown={this.handleKeyDown}
                                                                        className={this.state.cursor === key ? `activeClass userGroup ${changeError ? 'noUser' : ''}` : 'userGroup animated slow'} key={obj.UserId} onClick={() => this.clickedItem(obj, key)} >
                                                                        {this.state.clickedItem === obj.UserId
                                                                            &&
                                                                            <label className="userPic">
                                                                                <UserImage profileUrl={obj.ProfileImage} size="32" profileName={obj.DisplayName} />
                                                                                <span className="badges profileChecked green"></span>
                                                                            </label>
                                                                            ||
                                                                            <label className="userPic">
                                                                                <span className="userPicIcon">
                                                                                    <UserImage profileUrl={obj.ProfileImage} size="32" profileName={obj.DisplayName} />
                                                                                </span>
                                                                            </label>
                                                                        }
                                                                        <span className="userInfo">{obj.DisplayName} <label>{obj.Email}</label></span>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>
                                                }
                                                {!changeSuccess && <footer>
                                                    {this.state.selectedSponsor && !changeError && <button className="btn buttonGradient " tabIndex={2} onClick={this.changeOwner}>
                                                        {this.props.buttonLoading && <LoaderComponent />}
                                                        <span style={{ visibility: this.props.buttonLoading ? "hidden" : "" }}>Change</span>
                                                    </button>} 
                                                    <button className={`btn link ${this.props.buttonLoading ? 'disabled' : ''}`} onClick={this.cancelClick} tabIndex={1}>Cancel</button>
                                                </footer>}
                                            </React.Fragment>
                                            :
                                            (
                                                expand && !(changeSuccess || changeError) &&
                                                <div>
                                                    <LoaderComponent />
                                                </div>
                                            )
                                        }
                                        {expand && (changeSuccess || changeError) &&
                                            <div className={`ownerChangeSuccess ${changeSuccess ? 'animated slow delay-2s' : ''}`}>
                                                {changeSuccess &&
                                                    <div className="success-checkmark">
                                                        <div className="check-icon">
                                                            <span className="icon-line line-tip"></span>
                                                            <span className="icon-line line-long"></span>
                                                            <div className="icon-circle"></div>
                                                            <div className="icon-fix"></div>
                                                        </div>
                                                    </div>
                                                }
                                                {changeError &&
                                                    <div className="errorMessage animated delay-5ms fast fadeInUp">
                                                        {this.state.errorMsg}
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                }
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    workkard: state.workkardDetail.workkardDetail,
    activityDetail: state.workkardDetail.activityDetail,
    errorValidationMessage: state.validationError,
    isLoading: state.isLoading,
    buttonLoading: state.workkardDetail.buttonLoaders.changeOwner,
});

const mapDispatchToPros = (dispatch) => ({
    clearErrorValidationMessage: bindActionCreators(clearErrorValidationMessage, dispatch),

});

export default connect(mapStateToProps, mapDispatchToPros)(changeOwnerPopUp)
